import { Charts } from './Charts';
import SummaryChartsDataProvider from './contexts/SummaryChartsDataContext';

const SummaryWrapper = () => {
    return (
        <SummaryChartsDataProvider>
            <Charts />
        </SummaryChartsDataProvider>
    );
};

export default SummaryWrapper;
